import { mathFormat } from '@/pages/home/utils/search';
import React, { memo, useMemo } from 'react';
import MetricsBoard from '@/pages/intelligence/components/MetricsBoard';
// import Loading from '@/pages/intelligence/components/Loading';
import Loading from '@/pages/dashboard/components/Loadings';
import MarketBar from '../../components/MarketGenreBarChart';
import { formatBarSrice, tooltipFormatter } from '../utils';
import { ComponentProps } from './MarketEchartsMap';
import MarketDetailsBottom from './MarketDetailsBottom';
import { useIntl } from 'umi';
import NoData from '@/pages/intelligence/components/NoData';

const MArketsSUmmaryTop = ({
  changeValue,
  type,
  newzooTitle,
  cardDatas: data,
  cardLoading: loading,
}: ComponentProps<typeof MarketDetailsBottom>) => {
  const { formatMessage } = useIntl();

  const {
    legend: devLegend,
    xAxisData: devxAxisData,
    series: devseries,
    ...restProps
  } = formatBarSrice(data?.device_history || data?.players_history, false, type, false) as any;
  const {
    legend: regionLegend,
    xAxisData: regionxAxisData,
    series: regionseries,
    ...regionRestProps
  } = formatBarSrice(data?.region_history || data?.payers_history, false, type, false) as any;
  const {
    legend: genreLegend = [],
    xAxisData: genrexAxisData = [],
    series: genreseries = [],
    ...genrerestProps
  } = formatBarSrice(data?.genre_history || data?.payers_region_history, type, true, false);

  // 三图表toolTip格式化
  const legendTooltipFormatter = (praam: any) => {
    if (!type) return null;
    if (praam.name === 'YoY') return formatMessage({ id: 'dbi_global_view_play_Abbreviation_year' });
    return null;
  };
  // 三图表
  const globalObj = {
    title: newzooTitle?.header,
    metricsBoard: {
      title: type ? `${changeValue} ${formatMessage({ id: 'dbi_global_view_year_revenue' })}` : '',
      num: mathFormat(data?.total),
      textList: [
        {
          value: 'YOY',
          text: `${(data?.total_dod * 100).toFixed(0)}%` || '-',
        },
      ],
    },
    chartList: [
      {
        title: newzooTitle?.topLeft,
        chartData: (
          <div className="chart-placeholder">
            {loading ? (
              <Loading style={{ height: '160px' }} />
            ) : (
              <>
                {devseries && Array.isArray(devseries) && devseries?.length > 0 ? (
                  <MarketBar
                    {...{
                      xAxisData: devxAxisData,
                      series: devseries,
                      tooltipFormatter,
                      legendTooltipFormatter,
                      tooltipTitle: newzooTitle?.tooltipTitleLeft,
                      legend: devLegend,
                      ...restProps,
                    }}
                  />
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        ),
        child: '',
      },
      {
        title: newzooTitle?.topCenter,
        chartData: (
          <div className="chart-placeholder">
            {loading ? (
              <Loading style={{ height: '160px' }} />
            ) : (
              <>
                {regionseries && Array.isArray(regionseries) && regionseries?.length > 0 ? (
                  <MarketBar
                    {...{
                      xAxisData: regionxAxisData,
                      series: regionseries,
                      tooltipFormatter,
                      legendTooltipFormatter,
                      tooltipTitle: newzooTitle?.tooltipTitleCenter,
                      legend: regionLegend,
                      ...regionRestProps,
                    }}
                  />
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        ),
        child: '',
      },
      {
        title: newzooTitle?.topRight,
        chartData: (
          <div className="chart-placeholder">
            {loading ? (
              <Loading style={{ height: '160px' }} />
            ) : (
              <>
                {genreseries && Array.isArray(genreseries) && genreseries?.length > 0 ? (
                  <MarketBar
                    {...{
                      xAxisData: genrexAxisData,
                      series: genreseries,
                      tooltipFormatter,
                      legendTooltipFormatter,
                      tooltipTitle: newzooTitle?.tooltipTitleRight,
                      legend: genreLegend,
                      ...genrerestProps,
                    }}
                  />
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        ),
        child: '',
      },
    ],
  };

  return (
    <div className="dbi-revenue-margin">
      {loading ? (
        <div className="dbi-metrics-board">
          <Loading />
        </div>
      ) : (
        <MetricsBoard data={globalObj} />
      )}
    </div>
  );
};

export default memo(MArketsSUmmaryTop);
